import { css } from 'linaria';

export const variantAxis = css`
  display: block;
  box-sizing: border-box;
  margin-right: -12px;
  opacity: 1;

  transition: opacity 0.15s;

  &.invisible {
    opacity: 0;
  }
`;

export const axisTitle = css`
  font-weight: 500;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  color: #666666;
`;

export const axisPointLabelStyles = css`
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  color: #666666;
`;

export const pointsListWrapper = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const pointListShowMoreBtn = css`
  min-width: 82px;
  padding: 10px 6px !important;
  margin-top: 12px;

  font-style: normal;
  text-align: center;

  background: #f0f1f2;
  border: none;
  outline: none;
`;

export const hideElement = css`
  display: none;
`;

export const hideContainer = css`
  opacity: 0;
`;

export const showContainer = css`
  opacity: 1;
`;

export const showAllVariants = css`
  display: block;
`;

export const axisPointsList = css`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;
  flex-wrap: wrap;
  width: 100%;
  overflow-x: visible;
  overflow-y: visible;

  &.apply-folding-constraints {
    flex-grow: 0;
    flex-basis: var(--folding-constraint, 100%);
  }
`;

export const axisPointsListOneLine = css`
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const axisPointsListOfImages = css`
  height: 64px;
  &.unfolded {
    height: max-content;
  }
`;

export const unstyledButton = css`
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  margin: 0;
  padding: 0;
  letter-spacing: 0.2px;
`;

export const axisPointWrapper = css`
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  padding-right: 11px;
  margin: 0;
  margin-top: 12px;
`;

export const imageOfPuncturePoint = css`
  opacity: 0.2;
`;
